import request, { REQUEST_METHODS } from '@api/Request';
import { AquaticResourceEndpoints } from './config';
import {
  AddAquaticResourceResponse,
  DeleteAquaticResourceRequest,
  DeleteAquaticResourceResponse,
  GetAquaticResourceGeometryBoundaryValidationResponse,
  GetAquaticResourceGeometriesResponse,
  GetAquaticResourceMismatchQueryParams,
  GetAquaticResourceMismatchResponse,
  GetAquaticResourceRequest,
  GetAquaticResourceResponse,
  GetAquaticResourcesQueryParams,
  GetAquaticResourceUsaceDistrictValidationResponse,
  GetAquaticResourceWaterNamesResponse,
  GetValidateAquaticResourcesQueryParams,
  GetValidationAquaticResourcesResponse,
  UpdateAquaticResourceResponse,
} from './types';

export default class AquaticResourceService {
  public static readonly getAquaticResources = (
    params: GetAquaticResourcesQueryParams
  ): Promise<GetAquaticResourceResponse> => {
    return request({
      url: AquaticResourceEndpoints.aquaticResources(),
      method: REQUEST_METHODS.GET,
      params,
    });
  };
  public static readonly getAquaticResourceGeometries = (): Promise<GetAquaticResourceGeometriesResponse> => {
    return request({
      url: AquaticResourceEndpoints.getAquaticResourceGeometries(),
      method: REQUEST_METHODS.GET,
    });
  };
  public static readonly getAquaticResourcesWaterNames = (): Promise<GetAquaticResourceWaterNamesResponse> => {
    return request({
      url: AquaticResourceEndpoints.getAquaticResourcesWaterNames(),
      method: REQUEST_METHODS.GET,
    });
  };
  public static readonly addAquaticResources = (
    data: GetAquaticResourceRequest
  ): Promise<AddAquaticResourceResponse> => {
    return request({
      url: AquaticResourceEndpoints.aquaticResources(),
      method: REQUEST_METHODS.POST,
      data,
    });
  };
  public static readonly updateAquaticResources = (
    data: GetAquaticResourceRequest
  ): Promise<UpdateAquaticResourceResponse> => {
    return request({
      url: AquaticResourceEndpoints.aquaticResources(),
      method: REQUEST_METHODS.PUT,
      data,
    });
  };
  public static readonly deleteAquaticResources = (
    data: DeleteAquaticResourceRequest
  ): Promise<DeleteAquaticResourceResponse> => {
    return request({
      url: AquaticResourceEndpoints.aquaticResources(),
      method: REQUEST_METHODS.DELETE,
      data,
    });
  };
  public static readonly deleteAllAquaticResources = (
    data: DeleteAquaticResourceRequest
  ): Promise<DeleteAquaticResourceResponse> => {
    return request({
      url: AquaticResourceEndpoints.aquaticResources(),
      method: REQUEST_METHODS.DELETE,
      data,
    });
  };
  public static readonly validateAquaticResources = (
    params: GetValidateAquaticResourcesQueryParams
  ): Promise<GetValidationAquaticResourcesResponse> => {
    return request({
      url: AquaticResourceEndpoints.validateAquaticResources(),
      method: REQUEST_METHODS.GET,
      params,
    });
  };
  public static readonly validateAquaticResourceUsaceDistrict =
    (): Promise<GetAquaticResourceUsaceDistrictValidationResponse> => {
      return request({
        url: AquaticResourceEndpoints.validateAquaticResourceUsaceDistrict(),
        method: REQUEST_METHODS.GET,
      });
    };
  public static readonly getAquaticResourceMismatch = (
    params: GetAquaticResourceMismatchQueryParams
  ): Promise<GetAquaticResourceMismatchResponse> =>
    request({
      url: AquaticResourceEndpoints.getAquaticResourceMismatch(),
      method: REQUEST_METHODS.GET,
      params,
    });
  public static readonly validateAquaticResourceGeometryBoundary =
    (): Promise<GetAquaticResourceGeometryBoundaryValidationResponse> => {
      return request({
        url: AquaticResourceEndpoints.validateAquaticResourceGeometryBoundary(),
        method: REQUEST_METHODS.GET,
      });
    };
}
